module.exports = __webpack_public_path__ + "static/media/Banner membresía Platinum.af988abf.svg";